import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchType: localStorage.getItem('searchType') || 'customer',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchType: (state, action) => {
      state.searchType = action.payload;
      localStorage.setItem('searchType', action.payload);
    },
  },
});

export const { setSearchType } = searchSlice.actions;

export default searchSlice.reducer;
